import { render, staticRenderFns } from "./CreateGroupOutDialog.vue?vue&type=template&id=aa06cb26&scoped=true"
import script from "./CreateGroupOutDialog.vue?vue&type=script&lang=js"
export * from "./CreateGroupOutDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateGroupOutDialog.vue?vue&type=style&index=0&id=aa06cb26&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa06cb26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa06cb26')) {
      api.createRecord('aa06cb26', component.options)
    } else {
      api.reload('aa06cb26', component.options)
    }
    module.hot.accept("./CreateGroupOutDialog.vue?vue&type=template&id=aa06cb26&scoped=true", function () {
      api.rerender('aa06cb26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentDialog/CreateGroupOutDialog.vue"
export default component.exports